<script lang="ts">
  import type { Banner } from "$lib/gql/genCms/codegen";

  import { isInternalLink, linkTo } from "$lib/utils/url";
  export let bannerData: Banner;
  function targetLink(href: string): string {
    // check for external link
    if (!isInternalLink(href)) {
      return "_blank";
    }
    return "_self";
  }
</script>

<style lang="scss">
  .active {
    text-decoration: none;
  }
</style>

{#if bannerData.link1 && !bannerData.link2}
  <a
    class="active"
    href={linkTo(bannerData.link1.href)}
    target={targetLink(bannerData.link1.href)}
  >
    <slot />
  </a>
{:else if bannerData.link1 && bannerData.link2}
  <slot />
{:else}
  <slot />
{/if}
